import Vue from 'vue'
import Router from 'vue-router'
import CategorySelection from './views/CategorySelection'
import Live from './views/Live.vue'
import LiveLivingOption from './views/LiveLivingOption'
import LiveSubsection from './views/LiveSubsection'
import LiveProperty from './views/LiveProperty'
import Page from './views/Page.vue'
import Rest from './views/Rest.vue'
import _ from 'lodash'

import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Rest
    },
    {
      name: 'category-selection',
      path: '/select',
      component: CategorySelection
    },
    {
      name: 'page',
      path: '/category/:categoryId/page/:pageId',
      component: Page
    },
    {
      name: 'live',
      path: '/live',
      component: Live
    },
    {
      name: 'live-page',
      path: '/live/page/:pageId',
      component: Page
    },    
    {
      name: 'living-option',
      path: '/live/:livingOptionId',
      component: LiveLivingOption
    },
    {
      name: 'subsection',
      path: '/live/:livingOptionId/subsection/:subsectionId',
      component: LiveSubsection
    },
    {
      name: 'property',
      path: '/live/:livingOptionId/subsection/:subsectionId/property/:propertyId',
      component: LiveProperty
    },    
  ]
})

// TODO: route guard bottombar visiblilty - is there a better way of doing this?
// TODO: handle skipping category selection better
router.beforeEach((to, from, next) => {
  if (to.path === '/select') {
    if (store.getters.navigation && store.getters.navigation.length === 1) {
      store.state.isBottomBarVisible = true
      const category = store.getters.navigation[0]
      const defaultChild = _.find(category.children, child => {
        return child._id === category.defaultChildId
      })
      const newTo = defaultChild ? `/category/${category._id}/page/${defaultChild.pageId}` : `/category/${category._id}/page/${category.children[0].pageId}`
      if (from.path === newTo) {
        next(false)
      } else {
        next(newTo)
      }
    } else {
      store.state.isBottomBarVisible = false    
      next()
    }
  } else if (['/'].includes(to.path)) {
    store.state.isBottomBarVisible = false     
    next()
  } else {
    store.state.isBottomBarVisible = true
    next()
  }
})

export default router
